<template>
	<div class="background-rows-factors">
		<p class="title"
			:style="`color:${$appColors.info}`"
		>{{ title }}</p>
		<v-layout
			wrap
			align-center
			justify-space-between
			px-3 py-2
			class="flex-factors"
			v-for="item in rows"
			:key="`${item.id}-${item.areaId}`"
		>
			<v-flex xs2>
				<v-checkbox
					class="check-factor mt-0 pt-0"
					:class="{ 'input-disabled': item.disabled }"
					:id="`item-${item.areaId}-${item.id}`"
					hide-details
					height="12px"
					color="success"
					:disabled="item.disabled"
					v-model="item.selected"
					@change="$emit('check', item)"
				></v-checkbox>
			</v-flex>
			<v-flex xs8>
				<label
					:for="`item-${item.areaId}-${item.id}`"
					class="name-content text-xs-left"
					:style="`color:${$appColors.info}`"
					:class="{
						'label-selected' : item.selected,
					}"
					:aria-disabled="item.disabled"
				>
					{{ item.name }}
				</label>
			</v-flex>
			<v-flex xs2>
				<app-tooltip-button
					color="primary"
					icon="remove_red_eye"
					text="Ver Detalle"
					:size="18"
					@click-icon="$emit('select-factor', item)"
				></app-tooltip-button>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'rows-factors',
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
		title: {
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.v-input {
	flex: none;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
	background-color: none;
}

.title {
	font-family: map-get($fonts, bold);
	font-size: map-get($sizes, xlarge);
	padding-left: 27px;
}

.flex-factors {
	border-top: 1px solid map-get($colors, gray-light);
}

.material-icons {
	font-size: 15px !important;
}

.v-input--selection-controls {
	margin-top: 5px;
}

.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
	box-shadow: none;
}

.name-content {
	font-size: map-get($sizes, small);
}

.margin-left {
	margin-left: 23.5px;
}

.background-rows-factors {
	background-color: map-get($colors, white);
	border: solid 1px map-get($colors, gray-slider);
	border-radius: 9px;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02);
	margin: 0 35px 20px 0;
	padding-top: 20px;
	width: 100%;
}

.input-disabled {
	opacity: .2;
}

.label-selected {
	font-family: map-get($fonts, bold);
}
</style>




// WEBPACK FOOTER //
// src/components/surveys/rows-factors.vue